/* eslint-disable */
import React from 'react';
import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { Text } from 'src/onboarding/components/typography/Text/Text';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';

function Page() {
  const cookingTime = useStore((state) => state.cookingTime);
  const setCookingTime = useStore((state) => state.setCookingTime);
  const { onNext, onPrev, currentIndex } = useNav();

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.cookingTime.title')}</Title>
        <Text className='description' size='m' medium>
          {t('onboarding.cookingTime.subTitle')}
        </Text>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={cookingTime}
          onChange={(value) => {
            setCookingTime(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'cooking-time',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={'Less than 15 minutes'}>
            <span>⏱️</span> {t('onboarding.cookingTime.options.15min')}
          </Option>
          <Option value={'Around 30 minutes'}>
            <span>🍲</span> {t('onboarding.cookingTime.options.30min')}
          </Option>
          <Option value={'Up to an hour'}>
            <span>🥘</span> {t('onboarding.cookingTime.options.hour')}
          </Option>
          <Option value={'I love cooking and don’t mind spending time'}>
            <span>👨‍🍳</span> {t('onboarding.cookingTime.options.dontMind')}
          </Option>
        </Check>
      </div>
    </div>
  );
}
export default Page;
